<template>
  <div>
    <div v-for="editable in editables" class="kp-list-group-item clearfix">
      <label
        class="kp-row box-title box-title__button"
        @click="sidebarChangePanel('modifiers');sidebarSetElement(editable)">
        {{ editable.getAttribute('klickbox-edit-label') }}
        <div class="pull-right">
          <span class="btn is-circular has-icon"><i class="fa fa-cog"></i></span>
        </div>
      </label>
      <span></span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      editables: [],
    };
  },
  mounted() {
    const selector = '[klickbox-edit-item]:not([klickbox-edit-item-dad])';
    this.editables = Array.from(document.querySelectorAll(selector));
  },
  updated() {
    const selector = '[klickbox-edit-item]:not([klickbox-edit-item-dad])';
    setTimeout(() => {
      this.editables = Array.from(document.querySelectorAll(selector));
    }, 0);
  },
  methods: mapActions([
    'sidebarChangePanel',
    'sidebarSetElement',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Modifiers.vue?1998904a
 **/